import styled from 'styled-components';

export const AddedBonusContainer = styled.div`
  background-color: #fdfaed;
  margin: 40px 7.5%;
  padding: 24px 0;

  @media (max-width: 720px) {
    margin: 30px 0;
    padding: 20px 0;
  }
`;

export const AddedBousHeading = styled.h2`
  background-color: #fceaa1b5;
  color: hsl(0deg, 0%, 0%, 78%);
  padding: 10px 10%;
  font-size: clamp(14px, 2vw, 24px);
  margin-bottom: 10px;

  @media (max-width: 720px) {
    padding: 10px 26px;
  }
`;

export const BonusSubheading = styled.h3`
  padding: 10px 10% 0;
  color: hsl(0deg, 0%, 0%, 78%);
  font-size: clamp(12px, 2vw, 16px);
  @media (max-width: 720px) {
    padding: 6px 26px 0;
  }
`;
